import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/client";

import {
  Column,
} from "../../genericComponents/Layout";
import UserCard from "../components/UserCard";
import UserCardSkeleton from "../components/UserCardSkeleton";
import SideFilters from "../components/SideFilters";
import {
  CONNECTED_USERS,
  USERS_QUERY_PG,
} from "../../../helpers/graphqlQueries";
import { Context } from "../../../context/globalContext";
import { GApageView } from "../../../app";
import { Button } from "../../genericComponents";
import useConnectionUsers from "../../hook/useConnectionUsers";

const filterOrder=['GABAnator','LifeTime','GABAmember','GABABronze','free']

export default function PeoplePageScreen() {
  const { state: { user } } = useContext(Context);

  const usernameSender = user.username;

  const {
    loading: loadingConnect,
    data: connectResponse,
    refetch: fetchConnect,
  } = useQuery(CONNECTED_USERS, { variables: { username: usernameSender } });

  const { data: userResponse, loading: loadingUsers } = useQuery(USERS_QUERY_PG);
  const { handleConnect } = useConnectionUsers(onCompleted);

  const [filteredData, setFilteredData] = useState(null);
  const [users, setUsers] = useState([]);
  const [limit, setLimit] = useState(5);
  const [limitPosible, setLimitPosible] = useState(0);

  useEffect(() => {
    const userFiltered = userResponse?.user_data?.filter(filterUser) || [];
    userFiltered.sort(function (a, b) {
      
      var delta = (filterOrder.indexOf(a.user_account?.membership_type) - filterOrder.indexOf(b.user_account?.membership_type))*10;
      // test, if the indices are the same
      if (delta === 0) {
        if(a.avatar!==''&&b.avatar==='') delta += -5
        if(a.avatar===''&&b.avatar!=='') delta += 5
        //if(a.avatar==='') return 0
        if(a.name&&!b.name) delta += -3
        if(!a.name&&b.name) delta += 3
        delta = a.name === b.name ? delta  : (a.name < b.name ? delta  -1 : delta + 1);
        return delta
      }
      // otherwise return the delta
      return delta;
  });
    setLimitPosible(userFiltered.length);
    const userFilteredLimited = userFiltered.slice(0, limit);
    
    setUsers(userFilteredLimited);
  }, [userResponse, filteredData, limit]);

  async function handleConnectButtonPress(onConnect, username, usernameSender, email) {
    handleConnect(onConnect,username,usernameSender,user.name,email)
  }

  function onCompleted() {
    fetchConnect()
  }


  useEffect(() => {
    GApageView("People");
  }, []);

  function filterUser(user) {
    //if (!user.verified) return false;
    if (user.username === usernameSender) return false;
    if (filteredData?.username && filteredData?.username !== user.username)return false;
    if (filteredData?.class_status &&filteredData?.class_status !== user.class_status)return false;
    if (filteredData?.medical_school &&filteredData?.medical_school !== user.medical_school)return false;
    if (filteredData?.specialty && !user.specialties?.includes(filteredData?.specialty)) return false;
    if (filteredData?.looking && !user.looking_for?.includes(filteredData?.looking))return false;
    if (filteredData?.offer && !user.can_offer?.includes(filteredData?.offer))return false;
      
    return true;
  }

  return (
    <GenericContainer>
      <GenericSubContainer>
        <SideFilters
          onPressFilter={(f) => {
            setFilteredData(f);
            setLimit(5);
          }}
        />
        <CardsContainer>
          {loadingUsers ? (
            Array.from({ length: 4 }).map((element, index) => (
              <UserCardSkeleton key={index} />
            ))
          ) : users.length ? (
            users.map((user, index) => (
              <UserCard
                key={index}
                user={user}
                onConnect={
                  connectResponse.users_connection?.find(
                    (unames) => unames?.usernames?.includes(user.username)
                  )
                }
                handleConnectButtonPress={handleConnectButtonPress}
              />
            ))
          ) : (
                <CardContainer>Nothing here</CardContainer>
              )}
          {!loadingConnect && limitPosible > limit && (
            <LoadMoreButton onClick={() => setLimit((l) => l + 5)}>
              Load More
            </LoadMoreButton>
          )}
        </CardsContainer>
      </GenericSubContainer>
    </GenericContainer>
  );
}

const GenericContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const GenericSubContainer = styled.div`
  width: 100%;
  display: flex;
  align-self: center;
  justify-content: center;
  margin-top: 50px;
  padding: 0 8px;
  ${(props) => props.theme.rules.narrowWidth}
  @media (max-width: 720px) {
    flex-direction: column;
  }
`;
const CardsContainer = styled(Column)`
  align-items: center;
  margin-left: 30px;
  min-width: 350px;
  width: 60%;
  @media (max-width: 920px) {
    width: 100%;
    margin-left: 0px;
  }
`;
const LoadMoreButton = styled(Button)`
  align-self: center;
  margin-bottom: 30px;
`;
const CardContainer = styled.div`
  background: ${(props) => props.theme.color.softYellow};
  border-radius: 6px;
  margin-bottom: 30px;
  display: flex;
  padding: 30px;
  position: relative;
  width: 100%;
  @media (max-width: 920px) {
    flex-direction: column;
  }
`;
